import { useTranslation } from "react-i18next";
import {
  ChallengeCardWrapper,
  ChallengeHeader,
  ChallengeAmount,
} from "./ChallengeUtils";
import { ChallengeInfoProps } from "@/pages/challenges/ChallengeInfo";

export const ChallengeCompletedCard = ({
  targetAmount,
}: ChallengeInfoProps) => {
  const { t } = useTranslation();

  return (
    <ChallengeCardWrapper isCompleted={true}>
      <div className="flex items-start justify-between">
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <ChallengeHeader
              text={t("challenge_successfully_completed")}
              textColor="text-orange-100"
            />
          </div>
          {targetAmount && (
            <ChallengeAmount amount={targetAmount} isCompleted={true} />
          )}
        </div>
      </div>
    </ChallengeCardWrapper>
  );
};
